import styled from 'styled-components'
import { ArrowDownIcon } from '@velasca/icons/arrow-down'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 1rem 1.2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (min-width: 769px) {
    padding: 2rem 3rem;
  }
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.serif.fontFamily};
  font-weight: 400;
  font-size: 3rem;
  letter-spacing: -2px;
  line-height: 1.25;
  text-align: center;
  margin: 3rem 0;

  @media (min-width: 1200px) {
    margin: 5rem 0;
  }
`

export const Subtitle = styled.li`
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0;
  margin: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.all-countries:not(.without-favorites) {
    margin-top: 3.5rem;
  }
`

export const InputContainer = styled.div`
  width: 100%;
  margin: 0 0 3rem 0;
  display: flex;
  gap: 1.5rem;
  justify-content: center;

  @media (min-width: 1200px) {
    margin: 0 auto 5rem auto;
  }
`

export const InputBar = styled.input`
  width: 100%;
  max-width: 60rem;
  height: 4.5rem;
  margin: 0;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1.25;
  padding: 1.5rem 1.7rem;
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: ${({ theme }) => theme.fonts.brand};
  box-sizing: border-box;

  &::placeholder {
    opacity: 0.8;
    font-family: ${({ theme }) => theme.fonts.brand};
  }

  @media (min-width: 1200px) {
    width: 40vw;
  }
`

export const ButtonSearch = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.text.primary};
  width: 4.4rem;
  height: 4.4rem;
  border: none;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`

export const Columns = styled.ul`
  padding: 0;
  list-style-type: none;
  column-count: 1;
  column-width: 100%;

  @media screen and (min-width: 480px) {
    column-count: 2;
    padding-left: 4rem;
  }

  @media screen and (min-width: 768px) {
    column-count: 3;
    padding-left: 4rem;
  }

  @media screen and (min-width: 992px) {
    column-count: 4;
    padding-left: 4rem;
  }
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`

export const CloseIcon = styled(ArrowDownIcon)`
  width: 1rem;
  height: 1rem;
`
